var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrolleyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15447 2.10217C2.78672 1.89216 2.31618 2.01627 2.10348 2.37936C1.89078 2.74246 2.01648 3.20705 2.38422 3.41706L4.62254 4.69528L7.47242 16.2823C6.50456 16.7941 5.84622 17.8022 5.84622 18.962C5.84622 20.6399 7.22379 22 8.9231 22C10.6224 22 12 20.6399 12 18.962V18.9558L18.8286 17.2001L19.1417 18.3686C19.2489 18.7687 19.6601 19.0062 20.0602 18.899C20.4603 18.7918 20.6978 18.3805 20.5905 17.9804L20.2814 16.8266L21.4244 16.5327C21.8356 16.427 22.082 16.0123 21.975 15.6064C21.8679 15.2005 21.4479 14.9571 21.0368 15.0628L11.6128 17.4857C11.094 16.5661 10.1055 15.9403 8.96755 15.9244L5.96228 3.70561L3.15447 2.10217Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.358 4.95629C10.0187 5.0472 9.75196 5.30947 9.65535 5.64718L9.04932 7.76572L17.8393 5.41047L16.2552 3.87878C16.0027 3.63461 15.6405 3.54084 15.3012 3.63175L10.358 4.95629Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00293 9.33111L18.6622 6.74292L19.9886 11.6933C20.1316 12.2267 19.815 12.7751 19.2815 12.918L11.5541 14.9886C11.0206 15.1315 10.4723 14.8149 10.3294 14.2815L9.00293 9.33111ZM11.5581 11.6228C11.158 11.7301 10.9206 12.1413 11.0278 12.5414C11.135 12.9415 11.5463 13.1789 11.9464 13.0717L14.3612 12.4247C14.7613 12.3175 14.9987 11.9062 14.8915 11.5061C14.7843 11.106 14.3731 10.8686 13.973 10.9758L11.5581 11.6228Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolleyCart);
export default __webpack_public_path__ + "static/media/trolley-cart.afe1838eb4fc200bf03a38c2055c5052.svg";
export { ForwardRef as ReactComponent };